import { useNowFlowNode } from "@/hooks/services/useFlow";
import {
  fillInPONodeCodes,
  financialFirstAuditNodeCodes,
  purchaseManagerAuditNodeCodesForRD,
  purchaseManagerAuditNodeCodesForRLD,
  purchasingStaffFillInNodeCodesForHighOrLow,
  purchaseManagerAuditNodeCodesForLow,
  uploadContractNodeCodes,
  createFixedAssetsNoNodeCodes,
  applicantAddOrUpdateFilesNodeCodesForHigh,
  purchaserAddOrUpdateFilesNodeCodesForHigh,
} from "../constant";
import { isMatch } from "@/utils/flow.helper";

/**
 * 自定义 Hook，用于匹配合同流程节点
 * @returns 包含节点匹配结果的对象
 */
export function useFlowNodeMatcher(insId?: number) {
  const currentNodeCode = useNowFlowNode(insId);

  return {
    isMatchPurchaseManagerAuditNodeForRLD: isMatch(
      purchaseManagerAuditNodeCodesForRLD,
      currentNodeCode,
    ),
    isMatchFillInPONode: isMatch(fillInPONodeCodes, currentNodeCode),
    isMatchPurchaseManagerAuditNodeForRD: isMatch(
      purchaseManagerAuditNodeCodesForRD,
      currentNodeCode,
    ),
    isMatchPurchasingStaffFillInNodeForHighOrLow: isMatch(
      purchasingStaffFillInNodeCodesForHighOrLow,
      currentNodeCode,
    ),
    isMatchPurchaseManagerAuditNodeForLow: isMatch(
      purchaseManagerAuditNodeCodesForLow,
      currentNodeCode,
    ),
    isMatchFinancialFirstAuditNode: isMatch(
      financialFirstAuditNodeCodes,
      currentNodeCode,
    ),
    isMatchUploadContractNode: isMatch(
      uploadContractNodeCodes,
      currentNodeCode,
    ),
    isMatchCreateFixedAssetsNoNode: isMatch(
      createFixedAssetsNoNodeCodes,
      currentNodeCode,
    ),
    isMatchApplicantAddOrUpdateFilesNodeForHigh: isMatch(
      applicantAddOrUpdateFilesNodeCodesForHigh,
      currentNodeCode,
    ),
    isMatchPurchaserAddOrUpdateFilesNodeForHigh: isMatch(
      purchaserAddOrUpdateFilesNodeCodesForHigh,
      currentNodeCode,
    ),
  };
}
